import { ShippingNoticeBanner } from '../components/ShippingNoticeBanner';
import { useShippingInfoService } from '../services/useShippingNoticeService';

export interface ShippingNoticeBannerContainerProps {}

export const ShippingNoticeBannerContainer: React.FC<React.PropsWithChildren<ShippingNoticeBannerContainerProps>> = () => {
  const { is_hide, notice, show_arrow_icon, handleClick } = useShippingInfoService();

  if (is_hide) {
    return null;
  }

  return (
    <ShippingNoticeBanner show_arrow_icon={show_arrow_icon} onClick={handleClick}>
      {notice}
    </ShippingNoticeBanner>
  );
};
